import { Spinner } from "evergreen-ui"
import RenderCofabComponent from "~/renderCofabComponent"
import { flatten, range, max } from "lodash"
import CurvesRadial from "~/components/curvesRadial"
import fetchGradients from "~/components/circuit/fetchGradients"

const orientations = {
  mixed3a: {
    71: 137,
    81: 326.5,
    92: 11,
    95: 78.5,
    104: 350.5,
    137: 273.5,
    145: 41,
    147: 222.5,
    163: 87,
    189: 267.5,
  },
  mixed3b: {
    324: 91.5,
    330: 145,
    340: 110,
    342: 22.5,
    343: 358,
    349: 181,
    379: 243,
    385: 290,
    388: 66.5,
    406: 268.5,
  },
}

// const neurons4a = [402]

export default class Hue extends Component {
  state = { weights: null, activeNeuron: null }

  componentWillMount() {
    const { neuronLayer = "mixed4a", curveLayer = "mixed3a" } = this.props
    fetchGradients("inceptionv1", curveLayer, neuronLayer).then(weights => {
      window._weights = weights
      this.setState({ weights })
    })
  }

  render() {
    const { weights, activeNeuron } = this.state
    const {
      curveLayer = "mixed3a",
      neuronLayer = "mixed4a",
      neurons = [408, 403, 402, 96, 26, 290, 410, 36],
      // neurons = range(50),
      // neurons = [6, 1],
    } = this.props

    const BannerRadial = ({ data, ...props }) => {
      const activeLayer = data.filter(({ layer }) => layer === curveLayer)[0]

      const size = 400
      return (
        <CurvesRadial
          {...activeLayer}
          size={size}
          fillOpacity={0.4}
          orientationType={"max"}
          {...props}
        />
      )
    }

    if (!weights) return <Spinner />

    const size = 120

    window._curveNeurons = Object.keys(orientations[curveLayer])

    const ColorGrid = ({ neuron, isNegative }) => {
      const maxValue = max(
        Object.keys(orientations[curveLayer]).map(curveNeuron => {
          let grad = weights[curveNeuron][neuron]
          // flip
          if (isNegative) {
            grad = grad.map(row => row.map(col => -col))
          }

          return max(flatten(grad))

          /*
          return Math.sqrt(
            sum(
              flatten(grad)
                .map(x => Math.max(0, x))
                .map(x => x * x),
            ),
          )
          */
        }),
      )

      return (
        <Surface
          position="relative"
          width={size}
          height={size}
          background="black"
        >
          {Object.keys(orientations[curveLayer]).map(curveNeuron => {
            let grad = weights[curveNeuron][neuron]

            // flip
            if (isNegative) {
              grad = grad.map(row => row.map(col => -col))
            }

            const tileSize = size / grad.length

            return (
              <Surface
                position="absolute"
                left={0}
                top={0}
                width={size}
                height={size}
                // background="black"
              >
                <svg width={size} height={size}>
                  {grad.map((row, rowIndex) =>
                    row.map((col, colIndex) => {
                      let opacity =
                        Math.pow(Math.max(0, grad[rowIndex][colIndex]), 2) /
                        Math.pow(maxValue, 2)

                      if (activeNeuron && activeNeuron !== +curveNeuron) {
                        opacity = 0
                      }

                      return (
                        <rect
                          strokeWidth={0}
                          key={rowIndex + ":" + colIndex}
                          x={colIndex * tileSize}
                          y={rowIndex * tileSize}
                          width={tileSize}
                          shapeRendering="crispEdges"
                          style={{
                            transition: "300ms ease-in all",
                            fill: `hsl(${orientations[curveLayer][curveNeuron]}, 66%, 60%)`,
                            opacity,
                          }}
                          height={tileSize}
                        />
                      )
                    }),
                  )}
                </svg>
              </Surface>
            )
          })}
        </Surface>
      )
    }

    return (
      <Surface
        flexFlow="row"
        alignItems="center"
        marginY={40}
        justifyContent="center"
        gridColumn="screen"
      >
        <RenderCofabComponent
          component={BannerRadial}
          additionalProps={{
            onActivateNeuron: activeNeuron => {
              console.log("active neuron is", activeNeuron)
              this.setState({ activeNeuron })
            },
          }}
          folder="radial-tuning-curve"
        />
        <Surface flexFlow="row" flexWrap="wrap" width={760} marginLeft={100}>
          {neurons.map(neuron => (
            <Surface flexFlow="row" marginX={10} marginY={20}>
              <Surface>
                <Text fontWeight={600} marginLeft={5} marginBottom={3}>
                  Negative
                </Text>
                <ColorGrid neuron={neuron} isNegative={true} />
              </Surface>
              <Surface>
                <Text fontWeight={600} marginLeft={5} marginBottom={3}>
                  {neuronLayer}:{neuron}
                </Text>
                <img
                  src={neuronFeatureVis("inceptionv1", neuronLayer, neuron)}
                  width={size}
                  height={size}
                />
              </Surface>
              <Surface>
                <Text fontWeight={600} marginLeft={5} marginBottom={3}>
                  Positive
                </Text>
                <ColorGrid neuron={neuron} isNegative={false} />
              </Surface>
            </Surface>
          ))}
        </Surface>
      </Surface>
    )
  }
}
